import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import ModalForm from "../../../../../../components/modalComponents/ModalForm";

import { useSubmitForm } from "../../../../../../hooks/useSubmitForm/useSubmitForm";
import {
    cuadroRequerimientosCrearConversacional, cuadroRequerimientosGetDataToCrearCasoAPI,
} from "../../../../../../consumers/backendApisUrls";
import CasoFormFiels from "./CasoFormFields";
import { CASO_KEYS } from "./casoKeys";
import {useManageGetRequest} from "../../../../../../hooks/useManageGetRequest/useManageGetRequest";

const NuevoCasoModal = ({
  toggleModal,
  refreshPage,
  idCuadroSede,

}) => {

  const SECTION_NAME = "RegistrarCaso";
  const [executeManageGet] = useManageGetRequest();
  const [dataToCreateCaso, setDataToCreateCaso] = useState();

    const getDataToCreateCaso = async () => {
        const api = cuadroRequerimientosGetDataToCrearCasoAPI(idCuadroSede);
        await executeManageGet(api, (res) => successGetDataToCreateCasoCallback(res), false);
    }

    const successGetDataToCreateCasoCallback = ({data}) => {
        setDataToCreateCaso(data)
    }

  const [formValuesCaso, setFormValuesCaso] = useState({
    [CASO_KEYS.IdCuadroSede]: idCuadroSede,
    [CASO_KEYS.EstadoCaso]: "Pendiente",
    [CASO_KEYS.TipoCaso]: "",
    [CASO_KEYS.TipoReferencia]: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitForm] = useSubmitForm();
  const isMounted = useRef(true);


  useEffect(() => {
      getDataToCreateCaso();
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setIsSubmitting(true); 
    try {
      await submitForm(
        Object.values(CASO_KEYS),
        cuadroRequerimientosCrearConversacional(),
        getPayload(),
        SECTION_NAME,
        successSubmitCallback,
        true,
      );
    } catch (error) {
      console.error(error);
    } finally {
      if (isMounted.current) setIsSubmitting(false);
    }
  };

  const getPayload = () => ({
    ...formValuesCaso,
  });

  const successSubmitCallback = async ({ data }) => {
    toggleModal();
    await refreshPage();
  };

  return (
    <ModalForm
      titulo="Nuevo caso"
      width="750px"
      showModal={toggleModal}
      isSubmitting={isSubmitting}
      saveButtonDisabled={isSubmitting}
      onSubmit={handleSubmit}
    >
      <div className="displayFlexWrap">
        <CasoFormFiels
          idCuadroSede={idCuadroSede}
          formValuesCaso={formValuesCaso}
          setFormValuesCaso={setFormValuesCaso}
          isEditable={true}
          SECTION_NAME={SECTION_NAME}
          dataToCreateCaso={dataToCreateCaso}
        />
      </div>
    </ModalForm>
  );
};

NuevoCasoModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  refreshPage: PropTypes.func.isRequired,
  idCuadroSede: PropTypes.number.isRequired,
  nombreResponsable: PropTypes.string,
};

NuevoCasoModal.defaultProps = {
  nombreResponsable: "",
};

export default NuevoCasoModal;
